import { render, staticRenderFns } from "./headerForm.vue?vue&type=template&id=27d82a20&scoped=true"
import script from "./headerForm.vue?vue&type=script&lang=js"
export * from "./headerForm.vue?vue&type=script&lang=js"
import style0 from "./headerForm.vue?vue&type=style&index=0&id=27d82a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d82a20",
  null
  
)

export default component.exports